import { palette } from '@/modules/defines/styles';
import styled from 'styled-components';
import Escalator from './Escalator';
import Stair from './Stair';
import Elevator from './Elevator';
import Exit from './Exit';

type Icon = 'stair' | 'escalator' | 'elevator' | 'exit';
interface MarkerProps {
  $left: string;
  $top: string;
  $translateX: string;
  $translateY: string;
}

interface IconProps {
  type: Icon;
  left: string;
  top: string;
  translateX: string;
  translateY: string;
}

const TransitPin = ({ type, left, top, translateX, translateY }: IconProps) => {
  return (
    <Icon
      $left={left}
      $top={top}
      $translateX={translateX}
      $translateY={translateY}
    >
      {type === 'stair' && (
        <Stair width="24" height="24" fill={palette.secondaryRed700} />
      )}
      {type === 'escalator' && (
        <Escalator width="24" height="24" fill={palette.secondaryRed700} />
      )}
      {type === 'elevator' && (
        <Elevator width="24" height="24" fill={palette.secondaryRed700} />
      )}
      {type === 'exit' && (
        <Exit width="24" height="24" fill={palette.secondaryRed700} />
      )}
    </Icon>
  );
};

const Icon = styled.i<MarkerProps>`
  display: flex;
  width: 1.5rem;
  height: 1.5rem;
  padding: 0.25rem;
  justify-content: center;
  align-items: center;

  border-radius: 0.25rem;
  background: #fff;
  border: 1px solid ${palette.secondaryRed700};

  position: absolute;
  z-index: 22;
  left: ${(props) => props.$left};
  top: ${(props) => props.$top};
  transform: translate(
    ${(props) => props.$translateX},
    ${(props) => props.$translateY}
  );
`;
export default TransitPin;
